import {StateEnum} from '../enum';

export const NAME = StateEnum.coreConfig;
